import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UUID } from 'angular2-uuid';
import { FileUploadService } from 'src/app/shared/services/fileupload.service';
import { AuthenticateService } from 'src/app/shared/services/authenticate.service';
import { Transportservice } from 'src/app/shared/services/transport.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { CognitoService } from 'src/app/shared/services/cognito.service';
import { TokenStorageService } from 'src/app/shared/services/token.service';

@Component({
  selector: 'app-packing-type',
  templateUrl: './packing-type.component.html',
  styleUrls: ['./packing-type.component.sass']
})
export class PackingTypeComponent implements OnInit {

  showPackingType: boolean = false;
  packingTypeArray: any = [];
  packingObj: any = {};
  loading: boolean;
  globalImgUrl: string;
  groupName: string;
  packingForm: FormGroup;
  type: string = 'save';
  showPage: boolean = true;
  collectionSize: any;
  searchStr: string = '';
  skip: number;
  page = 1;
  previousPage: any;
  packingImage: any;
  imageUploadService: string;
  packingUrl: string = '';

  constructor(private formBuilder: FormBuilder,
    private transportService: Transportservice,
    private fileUploadService:FileUploadService,
    private tokenService:TokenStorageService,
    private authService: AuthenticateService,) { }

  ngOnInit() {
    this.type = 'save';
    this.packingForm = this.formBuilder.group({
      packingType: ['', Validators.required],
      packingDescription: ['', Validators.required],
    });
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
    if (!this.groupName) {
      this.groupName = this.tokenService.getGroup();
      if (this.groupName)
        this.getAllPackingTypes(0);
    }
  }

  // ngDoCheck() {
  //   if (!this.globalImgUrl) {
  //     this.globalImgUrl = this.authService.s3url();
  //   }
  //   if (!this.groupName) {
  //     console.log("this.authService.getUserDetails('group') ", this.authService.getUserDetails('family_name'))
  //     this.groupName = this.tokenService.getGroup();
  //   }
  // }

  getAllPackingTypes(pskip) {
    this.loading = true;
    this.showPage = true;
    var count = { group: this.groupName }
    this.transportService.getPackingTypeCount(count).then((data: any) => {
      console.log("packingType COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size
        var options = {
          group: this.groupName,
          options: {
            limit: 20,
            sortFields: { createTs: -1 },
            skip: pskip
          }
        }
        this.packingTypeArray = [];
        this.transportService.getPackingType(options).then((data: any) => {
          console.log("packingType Data == ", data);
          if (data.length > 0) {
            this.packingTypeArray = data;
            console.log("packingTypeArray", this.packingTypeArray)
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
      } else {
        this.packingTypeArray = [];
        this.loading = false;
      }
    });
  }

  loadPage(pageNumber: number) {
    console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 20) - 20;
      this.previousPage = pageNumber;
      this.getAllPackingTypes(this.skip);
    }
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  imageInput(event) {
    console.log("event : ", event);
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.packingUrl = event.target.result;
      }
      let iuuid = UUID.UUID();
      this.imageUploadService = 'var_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
      this.packingImage = event.target.files[0]
      console.log("packingImage", this.packingImage)
    }
  }

  uploadFileToActivity() {
    console.log("dd ", this.imageUploadService, this.packingImage)
    if (this.packingImage != '') {
      // this.registerService.postFile(this.packingImage, this.imageUploadService).then(data => {
      // }, error => {
      //   console.log(error);
      // });
      this.fileUploadService.uploadFile(this.packingImage, this.imageUploadService);
    }
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  addPackingType() {
    this.type = 'save';
    this.packingUrl = '';
    this.packingForm.reset();
    this.showPackingType = true;
  }

  editPacking(packingData) {
    this.packingUrl = '';
    console.log("packingData", packingData);
    this.type = 'update';
    this.showPackingType = true;
    this.packingObj = packingData;
    this.packingUrl = this.globalImgUrl + this.packingObj.packingTypeImage;
    console.log("packingObj", this.packingObj);
  }

  cancelPacking() {
    this.packingForm.reset();
    this.packingUrl = '';
    this.showPackingType = false;
    this.getAllPackingTypes(0);
  }

  savePackingData() {
    this.loading = true;
    let uuid = UUID.UUID();
    this.packingObj.packingTypeId = uuid;
    this.packingObj.packingTypeImage = this.imageUploadService;
    this.packingObj.group = this.groupName;
    console.log("packing obj : ", this.packingObj);
    this.transportService.createPackingType(this.packingObj).then((data: any) => {
      console.log("save packing result : ", data);
      if (this.packingImage != undefined) {
        this.uploadFileToActivity();
      }
      if (data) {
        Swal({ title: "saved successfully!" });
        this.type = 'save';
        this.packingUrl = '';
        this.packingForm.reset();
        this.showPackingType = false;
        this.getAllPackingTypes(0);
      } else {
        this.loading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  updatePackingType() {
    this.loading = true;
    this.packingObj['packingTypeImage'] = this.imageUploadService != undefined ? this.imageUploadService : this.packingObj.packingTypeImage;
    console.log("update packingObj", this.packingObj);
    this.transportService.updatePackingType(this.packingObj).then((data: any) => {
      console.log("updatepacking result : ", JSON.stringify(data));
      if (this.packingImage != undefined) {
        this.uploadFileToActivity();
      }
      if (data) {
        this.type = 'save';
        this.packingUrl = '';
        this.packingForm.reset();
        this.showPackingType = false;
        this.getAllPackingTypes(0);
      } else {
        this.loading = false;
        Swal.fire(
          'Error',
          'Data not updated (please contact admin)',
          'error'
        )
      }
    })
  }

  searchByName() {
    if (this.searchStr != '') {
      var obj = {
        group: this.groupName,
        field: 'packingType',
        text: this.searchStr,
        tableName: 'transportPackingType',
      };
      console.log("search obj : ", obj)
      // this.toolService.getRegex(obj).then((data: any) => {
      //   console.log("searched", data)
      //   this.searchStr = '';
      //   this.packingTypeArray = [];
      //   if (data.length > 0) {
      //     this.packingTypeArray = data;
      //     this.showPage = false;
      //     console.log("packingTypeArray", this.packingTypeArray);
      //   }
      //   else {
      //     this.showPage = false;
      //   }
      // })
    }
  }

}
